module.exports = __webpack_public_path__ + "static/media/12.710ae6fa.jpg";